const getWarehouseCode = () => window.localStorage.getItem('wareCode')?.replace(/"/g, '') || '';

export { getWarehouseCode };
